<!-- 
	图片组件 Z01
	1、组件样式：一行一个、一行二个、一行三个、一大两小、轮播海报、横向滑动
	2、轮播图片数组
	3、图片样式（0正常 1投影）未实现
	4、图片倒角（0直角  1圆角）
	5、页面边距
	6、图片边距
	7、图片间距
	8、填充方式（填充、留白）
	9、轮播样式（样式一、样式二）
-->
<template>
	<view class="component-wrapper" :style="componentStyle">
		<!--一行一列-->
		<view v-if="data.showType === 1" :style="wrapperStyle" :indicatorStyle="indicatorStyle">
			<up-grid :border="false" :gap="getPx(data.marginTopBottom)" col="1">
			    <up-grid-item v-for="(item,index) in list" :key="index">
					<image :src="getImageUrl(item.picUrl)" :style="getItemStyle(item,data.showType)"  mode="scaleToFill" @click="navigateTo(item)"></image>
					<view v-if="fnCheckNull(item.picTitle)" class="image_title_position" >{{item.picTitle}}</view>
			    </up-grid-item>
			</up-grid>
		</view>

		<!--一行二列-->
		<!-- <view v-if="data.showType === 2" :style="wrapperStyle" :indicatorStyle="indicatorStyle">
			<up-grid :border="false" :gap="getPx(data.imgMarginLeftRight)" col="2">
			    <up-grid-item v-for="(item,index) in list" :key="index">
					<image :src="getImageUrl(item.picUrl)" :style="getItemStyle(item,data.showType)" mode="widthFix" @click="navigateTo(item)"></image>
					<view v-if="fnCheckNull(item.picTitle)" class="image_title_position" >{{item.picTitle}}</view>
			    </up-grid-item>
			</up-grid>
		</view> -->
		<view v-if="data.showType === 2" :style="wrapperStyle" :indicatorStyle="indicatorStyle">
			<up-grid :border="false" :gap="getPx(data.imgMarginLeftRight)" col="2">
			    <up-grid-item v-for="(item,index) in list" :key="index">
					<image :src="getImageUrl(item.picUrl)" :style="imgStyle" mode="widthFix" @click="navigateTo(item)"></image>
					<view v-if="fnCheckNull(item.picTitle)" class="image_title_position" >{{item.picTitle}}</view>
			    </up-grid-item>
			</up-grid>
		</view>

		<!--一行三列-->
		<view v-if="data.showType === 3" :style="wrapperStyle" :indicatorStyle="indicatorStyle">
			<up-grid :border="false" :gap="getPx(data.imgMarginLeftRight)" col="3">
			    <up-grid-item v-for="(item,index) in list" :key="index">
					<image :src="getImageUrl(item.picUrl)" :style="getItemStyle(item,data.showType)" @click="navigateTo(item)"></image>
					<view v-if="fnCheckNull(item.picTitle)" class="image_title_position" >{{item.picTitle}}</view>
				</up-grid-item>
			</up-grid>
		</view>	

		<!--一大两小-->
		<!-- <view v-if="data.showType === 8" :style="wrapperStyle" v-for="(item, index) in groupItems" :indicatorStyle="indicatorStyle">
			<up-box height="200px" gap="5px">
				<template #left>
					<image v-if="item[0]" :src="getImageUrl(item[0].picUrl)" :style="getItemStyle(item,data.showType)" mode="widthFix" @click="navigateTo(item)"></image>
					<image v-if="!item[0]" :src="defaultImage" :style="getItemStyle(item,data.showType)" mode="widthFix"></image>
				</template>
				<template #rightTop>
					<image v-if="item[1]" :src="getImageUrl(item[1].picUrl)" :style="getItemStyle(item,data.showType)" mode="widthFix" @click="navigateTo(item)"></image>
					<image v-if="!item[1]" :src="defaultImage" :style="getItemStyle(item,data.showType)" mode="widthFix"></image>
				</template>
				<template #rightBottom>
					<image v-if="item[2]" :src="getImageUrl(item[2].picUrl)" :style="getItemStyle(item,data.showType)" mode="widthFix" @click="navigateTo(item)"></image>
					<image v-if="!item[2]" :src="defaultImage" :style="getItemStyle(item,data.showType)" mode="widthFix"></image>
				</template>
			</up-box>
		</view> -->
		<view v-if="data.showType === 8" :style="wrapperStyle" v-for="(item, index) in groupItems" :indicatorStyle="indicatorStyle">
			<up-box height="200px" gap="5px">
				<template #left>
					<image v-if="item[0]" :src="getImageUrl(item[0].picUrl)" :style="getItemStyle(item,data.showType)" mode="scaleToFill" @click="navigateTo(item[0])"></image>
					<image v-if="!item[0]" :src="defaultImage" :style="getItemStyle(item,data.showType)" mode="scaleToFill"></image>
				</template>
				<template #rightTop>
					<image v-if="item[1]" :src="getImageUrl(item[1].picUrl)" :style="getItemStyle(item,data.showType)" mode="scaleToFill" @click="navigateTo(item[1])"></image>
					<image v-if="!item[1]" :src="defaultImage" :style="getItemStyle(item,data.showType)" mode="scaleToFill"></image>
				</template>
				<template #rightBottom>
					<image v-if="item[2]" :src="getImageUrl(item[2].picUrl)" :style="getItemStyle(item,data.showType)" mode="scaleToFill" @click="navigateTo(item[2])"></image>
					<image v-if="!item[2]" :src="defaultImage" :style="getItemStyle(item,data.showType)" mode="scaleToFill"></image>
				</template>
			</up-box>
		</view>

		<!--轮播图-->
		<!-- #ifdef H5 || MP-WEIXIN -->
		<up-swiper :indicator="false" :circular="false" v-if="data.showType === 4" :style="wrapperStyle" keyName="picUrl" :list="list" height="360rpx" class="swiper-box" circular  :indicatorStyle="indicatorStyle" @change="change">
		<!-- #endif -->
		<!-- #ifdef APP-PLUS -->
		<up-swiper :indicator="false" :circular="false" v-if="data.showType === 4" :style="wrapperStyle" keyName="picUrl" :list="list" height="335rpx" class="swiper-box" circular  :indicatorStyle="indicatorStyle" @change="change">
		<!-- #endif -->
			<template v-slot:default="{item}">
				<image :src="getImageUrl(item.picUrl)" :style="imgStyle" mode="scaleToFill" style="height: 200px;" @click="navigateTo(item)"></image>
			</template>
			<template v-if="data.indicatorCss === 'C1'" #indicator>
				<view
					class="indicator"
				>
					<!-- :class="[index === currentNum && 'indicator__dot--active']" -->
					<view
						class="indicator__dot"
						v-for="(item, index) in list"
						:key="index"
						:class="{'indicator__dot--active': list.length - 1 - index === currentNum}"
					>
					</view>
				</view>
			</template>
			<template v-if="data.indicatorCss === 'C2'" #indicator>
				<view
					class="indicator-num"
				>
					<text class="indicator-num__text">{{ currentNum + 1 }}/{{ list.length }}</text>
				</view>
			</template>
		</up-swiper>

		<!--横向滑动-->
		<!-- <up-swiper v-if="data.showType === 9" height="200px" :style="wrapperStyle" keyName="picUrl" :list="list"
			previousMargin="30"
			nextMargin="30"
			:autoplay="false"
			radius="5"
			bgColor="#ffffff"
			imgMode="heightFix"
		>
			<template v-slot:default="{item}">
				<image :src="getImageUrl(item.picUrl)" :style="imgStyle" style="height: 200px;" mode="aspectFill" @click="navigateTo(item)"></image>
			</template>
		</up-swiper> -->
		<up-scroll-list
		:indicator="false"
		indicatorBarWidth="0"
		style="padding-bottom: 0;"
		v-if="data.showType === 9" :style="wrapperStyle" :list="list">
			<view v-for="(item, index) in list" :key="index"
			>
				<!-- mode="scaleToFill" machineWidth -->
				<image :src="getImageUrl(item.picUrl)" @click="navigateTo(item)"
				style="width: 300rpx;height: 360rpx;"
				mode="scaleToFill"
				></image>
			</view>
		</up-scroll-list>
	</view>
</template>
<!--
{
	"id": "49c1c30e740711f0a3479c5c8ebcfe65",
	"companyId": "1",
	"shopId": "1",
	"decorateId": "ad0507d26f9f11f0a3479c5c8ebcfe65",
	"decorateModuleId": "49c0f4a6740711f0a3479c5c8ebcfe65",
	"showType": 4,
	"marginLeftRight": 0,
	"marginTopBottom": 0,
	"isHaveProjection": 0,
	"isFillet": 0, //图片倒角（0直角  1圆角）
	"isPadding": 0,
	"indicatorCss": "C1",
	"createTime": "2025-08-08 11:25:10",
	"imgMarginLeftRight": 0,
	"decoratePicDetailList": [{
		"id": "49c2d538740711f0a3479c5c8ebcfe65",
		"companyId": "1",
		"shopId": "1",
		"decorateModuleId": "49c0f4a6740711f0a3479c5c8ebcfe65",
		"decoratePicId": "49c1c30e740711f0a3479c5c8ebcfe65",
		"picUrl": "image/2025-08-05/161d07395f234250a52ab9236302c02e.png",
		"sort": 0,
		"picTitle": "",
		"createTime": "2025-08-08 11:25:10",
		"lastHeight": 142.00,
		"lastWidth": 298.00,
		"realWidth": 710.00,
		"realHeight": 346.00,
		"decoratePicHotareaList": [],
		"lastHeightNew": 145.222535
	}]
	}
-->

<script setup>
	import { onLoad, onShow } from '@dcloudio/uni-app'
	import defaultImage from "@/static/images/image.png";
	import {fnImgRequestPath, fnPxToRpx, fnPxToRpxNew, fnCheckNull} from "@/utils/utils";
	import { getCurrentInstance, reactive, ref, computed} from "vue";
	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this
	const props = defineProps({
		componentId: {
			type: String,
			default: ''
		},
		data: {
			type: Object,
			default () {
				return {
					//展示方式模板（1：一行一个  2：一行2个  3：一行三个  4：轮播海报  5：横向滑动 ） 
					"showType":{
						type: Number,
						default: 0
					},
					//背景颜色
					"backgroundColor": {
						type: String,
						default: '#ffffff'
					},
					//图片样式（0常 1投影）
					"isHaveProjection":{
						type: Number,
						default: 0
					},
					//图片倒角（0直角  1圆角）
					"isFillet" :{
						type: Number,
						default: 0
					},
					//填充方式（0 不留白   1周边留白   ）---仅轮播有值
					"isPadding":{
						type: Number,
						default: 0
					},
					//页面边距（存数字，margin左右），默认存0
					"marginLeftRight" :{
						type: Number,
						default: 0
					},
					//图片间距（存数字，margin上下），默认存0
					"marginTopBottom":{
						type: Number,
						default: 0
					},
					//图片间距
					"imgMarginLeftRight":{
						type: Number,
						default: 0
					},
					//指示器样式（C1：样式一、C2：样式二、C3：样式三、C4：样式四、C5：样式五）---仅轮播有值
					"indicatorCss":{
						type: String,
						default: "C1"
					},
					"list": []
				}
			}
		}
	})
	
	//图片索引
	const currentNum = ref(0);
	
	/**
	 * 组件背景样式
	 */
	const componentStyle = computed(() => {
		const {
			backgroundColor
		} = props.data;
		return `
			background-color: ${backgroundColor == undefined ? '#f8f8f8': ''};
		`;
	})
	
	/**
	 * 轮播图样式
	 */
	const wrapperStyle = computed(() => {
		const {
			marginLeftRight,
			marginTopBottom,
			backgroundColor
		} = props.data;
		return `
			background-color: ${backgroundColor == undefined ? '#f8f8f8': ''};
			margin-top: ${marginTopBottom}px;
			margin-bottom: ${marginTopBottom}px;
			margin-left: ${marginLeftRight}px;
			margin-right: ${marginLeftRight}px;
		`;
	})
	
	/**
	 * 指示器样式
	 */
	const indicatorStyle = computed(() => {
		const {
			indicatorCss
		} = props.data;
		if(indicatorCss === 'C2'){
			return `right:20px`
		}
		return ``
	})
	
	onShow(() => {
		// 屏幕宽度
		// let machineWidth = uni.getSystemInfoSync().windowWidth
		// console.log(machineWidth)
	})

	// 工具函数：根据 item 返回对应的 style 字符串或对象
	const getItemStyle = (item, showType) => {
		const {
			isFillet,// 是否圆角
			imgMarginLeftRight,
			isHaveProjection
		} = props.data;
		// 屏幕宽度
		let pmWidth = uni.getSystemInfoSync().windowWidth
		// 图片高度
		let marginTop = fnPxToRpx(item.marginTopBottom, pmWidth)
		let marginBottom = fnPxToRpx(item.marginTopBottom, pmWidth)
		let marginLeft = fnPxToRpx(item.imgMarginLeftRight, pmWidth)
		let marginRight = fnPxToRpx(item.imgMarginLeftRight, pmWidth)
		let returnStyle = `
			padding-left: ${imgMarginLeftRight}px;
			padding-right: ${imgMarginLeftRight}px;
			border-radius: ${isFillet == 1 ? 10 : 0}px;
		`;
		if(isHaveProjection == 1){// 是否投影
			returnStyle += `
				box-shadow: 0 0 5px 5px #f9f9f9;
			`;
			// 一行一列
			if(showType == 1) {
				let height = fnPxToRpxNew(2, item.lastWidth, item.lastHeightNew, pmWidth, 1, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				returnStyle += `
					width:100%;
					height: ${height}rpx;
				`;
				return returnStyle;
			}
			// 一行两列
			else if(showType == 2) {
				let height = fnPxToRpxNew(2, item.lastWidth, item.lastHeightNew, pmWidth, 2, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				// 图片宽度
				let width = fnPxToRpxNew(1, item.lastWidth, item.lastHeightNew, pmWidth, 2, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				returnStyle += `
					width: ${width}rpx;
				`;
				return returnStyle;
			}
			// 一行三列
			else if(showType == 3) {
				let height = fnPxToRpxNew(2, item.lastWidth, item.lastHeightNew, pmWidth, 3, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				// 图片宽度
				let width = fnPxToRpxNew(1, item.lastWidth, item.lastHeightNew, pmWidth, 3, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				returnStyle += `
					width:${width}rpx;
					height: 360rpx;
				`;
				return returnStyle;
			}
			// 一大两小
			else if(showType == 8) {
				let height = fnPxToRpxNew(2, item.lastWidth, item.lastHeightNew, pmWidth, 3, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				// 图片宽度
				let width = fnPxToRpxNew(1, item.lastWidth, item.lastHeightNew, pmWidth, 3, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				returnStyle += `
					width: 100%;
					height: 100%;
				`;
				return returnStyle;
			}
		} else {
			// 一行一列
			if(showType == 1) {
				let height = fnPxToRpxNew(2, item.lastWidth, item.lastHeightNew, pmWidth, 1, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				returnStyle += `
					width:100%;
					height: ${height}rpx;
				`;
				return returnStyle;
			}
			// 一行两列
			else if(showType == 2) {
				let height = fnPxToRpxNew(2, item.lastWidth, item.lastHeightNew, pmWidth, 2, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				// 图片宽度
				let width = fnPxToRpxNew(1, item.lastWidth, item.lastHeightNew, pmWidth, 2, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				returnStyle += `
					width: ${width}rpx;
				`;
				return returnStyle;
			}
			// 一行三列
			else if(showType == 3) {
				let height = fnPxToRpxNew(2, item.lastWidth, item.lastHeightNew, pmWidth, 3, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				// 图片宽度
				let width = fnPxToRpxNew(1, item.lastWidth, item.lastHeightNew, pmWidth, 3, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				returnStyle += `
					width:${width}rpx;
					height: 360rpx;
				`;
				return returnStyle;
			}
			// 一大两小
			else if(showType == 8) {
				let height = fnPxToRpxNew(2, item.lastWidth, item.lastHeightNew, pmWidth, 3, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				// 图片宽度
				let width = fnPxToRpxNew(1, item.lastWidth, item.lastHeightNew, pmWidth, 3, item.marginLeftRight, item.imgMarginLeftRight, item.isPadding)
				returnStyle += `
					width: 100%;
					height: 100%;
				`;
				return returnStyle;
			}
		}
	}

	/**
	 * 图片样式
	 */
	const imgStyle = computed(() => {
		const {
			isFillet,
			imgMarginLeftRight,
			isHaveProjection
		} = props.data;
		if(isHaveProjection == 1){
			return `
				width: 100%;
				border-radius: ${isFillet == 1 ? 10 : 0}px;
				box-shadow: 0 0 5px 5px #f9f9f9;
				height: 100%;
				padding-left: ${imgMarginLeftRight}px;
				padding-right: ${imgMarginLeftRight}px;
			`;
		}else{
			return `
				width: 100%;
				height: 100%;
				border-radius: ${isFillet == 1 ? 10 : 0}px;
				padding-left: ${imgMarginLeftRight}px;
				padding-right: ${imgMarginLeftRight}px;
			`;
		}
	})
	
	/**
	 * 图片列表
	 */
	const list = computed(() => {
		try {
			let list = [...props.data.decoratePicDetailList] || [];
			list = list.filter(item => item.picUrl != '');
			return list;
		} catch (err) {
			return [];
		}
	})
	
	/**
	 * 一大两小（3个一组）
	 */
	const groupItems = computed(() => {
		try {
			let list = [...props.data.decoratePicDetailList] || [];
			list = list.filter(item => item.picUrl != '');
			const result = [];
			for (let i = 0; i < list.length; i += 3) {
				result.push(list.slice(i, i + 3));
			}
			return result;
		} catch (err) {
			return [];
		}
	})
	
	/**
	 * 滑动切换
	 * @param {Object} e
	 */
	function change(e) {
		// console.log(e);
		currentNum.value = e.current
		// console.log(currentNum.value);
	}


	/**
	 * 页面跳转
	 * @param {Object} item
	 */
	function navigateTo(item) {
		let linkType = item.decorateLinkBo.linkType
		let decorateLinkBo = item.decorateLinkBo
		// console.log("item=", item)
		// console.log(item.decorateLinkBo)
		// console.log("linkType",linkType,decorateLinkBo)

		// 微页面
		if (linkType == 1) {
			uni.navigateTo({
				url: '/pages/microPage/microPage?activityId=' + item.decorateLinkBo.activityId
			})
		}
		// 商品详情
		else if (linkType == 2 || linkType == 13) {
			uni.navigateTo({
				url: '/pages/prodDetail/detail?prodId=' + decorateLinkBo.prodId,
			})
		}
		// 定位导航
		else if (linkType == 4) {
			uni.navigateTo({
				url: ''
			})
		}
		// 公众号文章
		else if (linkType == 5) {
			// uni.setStorageSync("_go_url", decorateLinkBo.linkUrl)
			/* uni.navigateTo({
				url: `/pages/webview/webview?url=${encodeURIComponent(decorateLinkBo.linkUrl)}`
			}) */
			
			const url = decorateLinkBo.linkUrl;
			if (!url) {
				uni.showToast({
					title: '链接无效',
					icon: 'none'
				});
				return;
			}
			
			// 模拟跳转延迟（实际中可去掉）
			setTimeout(() => {
				// 尝试跳转
				if (typeof plus !== 'undefined') {
					console.log("1")
					plus.runtime.openWeb(url, (error) => {
						// 跳转失败（如未安装抖音）
						console.error('跳转失败:', error);
						uni.showToast({
							title: '应用未安装',
							icon: 'none',
							duration: 500
						});
						// 此时用户可手动点击左上角返回
					});
				} else {
					console.log("2")
					// H5 环境
					window.open(url, '_blank');
					// H5 中无法判断是否打开成功，用户可自行返回
				}
				
			}, 800); // 给用户一点“正在跳转”的视觉反馈
		}
		// 悦享专区
		else if(linkType == 99) {
			uni.navigateTo({
				url: '/pages/prodList/prodList?inSource=001&isRegister=0'
			})
		}
		// 健康优库
		else if(linkType == 100) {
			uni.navigateTo({
				url: '/pages/prodList/prodList?inSource=004'
			})
		}
		// 兑换专区
		else if(linkType == 101) {
			uni.navigateTo({
				url: '/pages/prodList/prodList?inSource=007'
			})
		}
	}
	
	/**
	 * 获取图片地址
	 * @param {Object} imgUrl
	 */
	function getImageUrl(imgUrl){
		return fnImgRequestPath(imgUrl);
	}
	
	/**
	 * 获取像素
	 * @param {Object} num
	 */
	function getPx(num){
		return num + "px";
	}
	
</script>

<style lang="less" scoped>
	.component-wrapper {
		display: block;
		margin-left: auto;
		margin-right: auto;
		text-align: center;
		width: 100%;
		overflow: hidden;

		img {
			width: 100%;
		}
	}

	.swiper-box {
		height: 200px;
	}
	
	.indicator {
		display:flex;
		flex-flow:row-reverse wrap;
		justify-content: center;

		&__dot {
			 height: 6px;
			 width: 6px;
			 border-radius: 100px;
			 background-color: rgba(255, 255, 255, 0.35);
			 margin: 0 5px;
			 transition: background-color 0.3s;
	
			&--active {
				 background-color: #ffffff;
			 }
		}
	}

	.indicator-num {
		padding: 2px 0;
		background-color: rgba(0, 0, 0, 0.35);
		border-radius: 100px;
		width: 35px;
		display:flex;
		flex-flow:row-reverse wrap;
		justify-content: center;

		&__text {
			 color: #FFFFFF;
			 font-size: 12px;
		 }
	}

	.image_title_position{
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 58rpx;
		font-size: 24rpx;
		color: #fff;
		background-color: rgba(0,0,0,0.4);
		text-align: center;
		line-height: 58rpx;
	}
</style>